import { createGaSender } from 'reactApp/utils/ga';

export const sendDocumentsGa = createGaSender('documents');
export const sendDocumentPageGa = createGaSender('doc-page');
